// src/modules/app-views/account/pages/Subscription/tabs/RecordTab/AiBusinessContextCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Tooltip } from 'antd';
import { QuestionCircleOutlined, RobotOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { useDocumentContext } from 'components/core/DocumentProvider';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AiBusinessContextCard = ({ required=false, forceDisabled }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { viewMode } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
    const isDisabled = typeof forceDisabled !== 'undefined'
      ? forceDisabled
      : viewMode === 'view';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  const cardTitle = (
    <div className="text-muted">
      <RobotOutlined style={{ marginRight: 8 }} />
      {translateX('ai_context')}
      <Tooltip title={translateX('ai_business_context_tooltip')}>
        <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'normal' }} />
      </Tooltip>
    </div>
  );

  return (
    <Card title={cardTitle} className="no-shadow">
      <SimpleTextArea
        name="aiBusinessContext"
        label={translateX('ai_business_context')}
        placeholder={translateX('ai_business_context_placeholder')}
        type="textarea"
        rows={4}
        disabled={isDisabled}
        required={required}
      />
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AiBusinessContextCard;

// *******************************************************************************
// HELPERS
// *******************************************************************************
